import { useEffect } from "react";

const GTM_ID = "GTM-57TSHZ";
const GTM_SCRIPT_ID = "voopter-gtm-script";

export function GTM() {
  useEffect(() => {
    try {
      if (
        typeof window === "undefined" ||
        document.getElementById(GTM_SCRIPT_ID)
      ) {
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "gtm.js" });

      const script = document.createElement("script");
      script.id = GTM_SCRIPT_ID;
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      document.head.appendChild(script);

      console.log("✅ GTM script adicionado:", script);
    } catch (error) {
      console.warn("⚠️ Não foi possível inicializar o GTM:", error);
    }
  }, []);

  return null;
}
